import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    // resources: {
    //   en: { translation: translationsEn  },
    //   jp: { translation: translationsJp },
    // },
    lng: localStorage.getItem("i18nextLng"),
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });
